$( document ).ready(function() {
  // Left Menu Drawer
  (() => {
    const factorySideNav = function factorySideNav() {
      // DOM
      const showButtonEl = document.querySelector('.js-menu-show');
      const hideButtonEl = document.querySelector('.js-menu-hide');
      const sideNavEl = document.querySelector('.js-side-nav');
      const sideNavContainerEl = document.querySelector('.js-side-nav-container');
  
      // State
      let startX = 0;
      let currentX = 0;
      let touchingSideNav = false;
  
      const onTransitionEnd = function onTransitionEnd(evt) {
        sideNavEl.classList.remove('side-nav--animatable');
        sideNavEl.removeEventListener('transitionend', onTransitionEnd);
      };
  
      const showSideNav = function showSideNav() {
        sideNavEl.classList.add('side-nav--animatable');
        sideNavEl.classList.add('side-nav--visible');
        sideNavEl.addEventListener('transitionend', onTransitionEnd);
      };
  
      const hideSideNav = function hideSideNav() {
        sideNavEl.classList.add('side-nav--animatable');
        sideNavEl.classList.remove('side-nav--visible');
        sideNavEl.addEventListener('transitionend', onTransitionEnd);
      };
  
      const update = function update() {
        if (!touchingSideNav) return;
  
        requestAnimationFrame(update);
  
        const translateX = Math.min(0, currentX - startX);
        sideNavContainerEl.style.transform = `translateX( ${translateX}px )`;
      };
  
      const onTouchStart = function onTouchStart(evt) {
        if (!sideNavEl.classList.contains('side-nav--visible')) return;
  
        startX = evt.touches[0].pageX;
        currentX = startX;
  
        touchingSideNav = true;
        requestAnimationFrame(update);
      };
  
      const onTouchMove = function onTouchMove(evt) {
        if (!touchingSideNav) return;
  
        currentX = evt.touches[0].pageX;
      };
  
      const onTouchEnd = function onTouchEnd(evt) {
        if (!touchingSideNav) return;
  
        touchingSideNav = false;
  
        const translateX = Math.min(0, currentX - startX);
        sideNavContainerEl.style.transform = '';
  
        if (translateX < 0) hideSideNav();
      };
  
      const blockClicks = function blockClicks(evt) {
        evt.stopPropagation();
      };
  
      const addEventListeners = function addEventListeners() {
        showButtonEl.addEventListener('click', showSideNav);
        hideButtonEl.addEventListener('click', hideSideNav);
        sideNavEl.addEventListener('click', hideSideNav);
        sideNavContainerEl.addEventListener('click', blockClicks);
  
        // sideNavEl.addEventListener('touchstart', onTouchStart);
        // sideNavEl.addEventListener('touchmove', onTouchMove);
        // sideNavEl.addEventListener('touchend', onTouchEnd);
      };
  
      return {
        addEventListeners };  
    };
  
    const sideNav = factorySideNav();
  
    sideNav.addEventListeners();
  })();

  // Tabs For each page
  $( '.links a' ).on( 'click', function(e){	
    // Define variable of the clicked »a« element (»this«) and get its href value.
    var href = $(this).attr( 'href' );    
    // Run a scroll animation to the position of the element which has the same id like the href value.
    $( 'html, body' ).animate({
  		scrollTop: $( href ).offset().top
    }, '300' );  	
    // Prevent the browser from showing the attribute name of the clicked link in the address bar
    e.preventDefault();
  });

  $('.top-header-section').hover(function(){
    $(this).addClass("hover-div", 3000);
    },
    function(){
    $(this).removeClass("hover-div", 3000);
  }); 

  // home Blog Slider
  // $(".abz-featured-blog .regular").slick({
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         arrows: false,
  //         slidesToShow: 2,
  //         slidesToScroll: 2
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         arrows: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //     // You can unslick at a given breakpoint now by adding:
  //     // settings: "unslick"
  //     // instead of a settings object
  //   ]
  // });
  $(".abz-article-carousel .regular").slick({
    dots: true,
    infinite: true,
    slidesToShow:2,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});


$(".Click-here").on('click', function() {
   $(".custom-model-main").addClass('model-open');
}); 
  $(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
$('a.Click-here').click(function() {
  // Check for active
  $('.multicolumn-list .multicolumn-list__item').removeClass('active');
  //$(".flash_sale .tabs-nav li.tab_items .paginations").removeClass('active');
  $(this).parent().addClass('active');
  $(this).closest("li").addClass('active');
  
  // Display active tab
  let currentTab = $(this).attr('href');
  $('.custom-model-inner .faculty-details .faculty-block-details').hide();
  $(currentTab).show();
  //$('.productGrid').slick('refresh');
  return false;
});

$(".abz-foundation-list .Click-here2").on('click', function() {
   $(".abz-foundation-list .custom-model-mains").addClass('model-open');
}); 
  $(".abz-foundation-list .close-btn, .abz-foundation-list .bg-overlay").click(function(){
  $(".abz-foundation-list .custom-model-mains").removeClass('model-open');
});
$('.abz-foundation-list a.Click-here2').click(function() {
  // Check for active
  $('.abz-foundation-list .multicolumn-list .multicolumn-list__item').removeClass('active');
  //$(".flash_sale .tabs-nav li.tab_items .paginations").removeClass('active');
  $(this).parent().addClass('active');
  $(this).closest("li").addClass('active');
  
  // Display active tab
  let currentTab = $(this).attr('href');
  $('.abz-foundation-list .custom-model-inner .faculty-details .faculty-block-details').hide();
  $(currentTab).show();
  //$('.productGrid').slick('refresh');
  return false;
});

// ABZ VIDEO SLIDER
$( document ).ready(function() {
  const btns =document.querySelectorAll(".abz-video-slider .slide-btn");
    const slider =document.querySelectorAll(".abz-video-slider .video-bg");

    var slideVideo = function(index) {
      btns.forEach((btn) => {
        btn.classList.remove('active');
      });
      slider.forEach((slide) => {
        slide.classList.remove('active');
      });
      btns[index].classList.add('active');
      slider[index].classList.add('active');
    }

    btns.forEach((btn,i) => {
      btn.addEventListener('click', () => {
        slideVideo(i);
      })
    })
});